import request from '@/utils/request'

// 查询列表
export function apiScpMrpHorizontalSummaryReservePlanList (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/reservePlanList',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 动态表头
export function apiScpMrpHorizontalDatesDateDisplayList (query) {
  return request({
    url: '/scp/scpMrpHorizontalDates/dateDisplayList',
    method: 'get',
    params: query
  })
}

// 计划版本
export function apiScpMrpPlansPlanVersionBox (query) {
  return request({
    url: '/scp/scpMrpPlans/planVersionBox',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 发布
export function apiScpMrpHorizontalSummaryReservePlanRelease (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/reservePlanRelease',
    method: 'put',
    data: data
  })
}

// 整版发布
export function apiScpMrpHorizontalSummaryReservePlanFullRelease (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/reservePlanFullRelease',
    method: 'put',
    data: data
  })
}

// 撤回
export function apiScpMrpHorizontalSummaryReservePlanWithdraw (data) {
  return request({
    url: `/scp/scpMrpHorizontalSummary/reservePlanWithdraw/${data}`,
    method: 'post'
  })
}

// 列表-行保存
export function apiScpMrpHorizontalSummaryReservePlanEdit (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/reservePlanEdit',
    method: 'put',
    data: data
  })
}
